import React, { useState } from "react";
import { Breadcrumbs, Button, PageHeader } from "@opendate-app/setlist";

import { useSegmentEditContext } from "./SegmentEditContainer";
import { listHref } from "../shared/listUrlState";
import DataDrivenSegmentForm from "./DataDrivenSegmentForm";
import { ensureConditionsComplete } from "./FanFilters/conditionGate";
import { toastError } from "../../../shared/toastHelper";

const pageStyle = { display: "flex", flexDirection: "column", gap: 24, padding: "0 0 48px" };

const SegmentEdit = () => {
  const {
    csrfToken,
    team,
    segment,
    setSegment,
    aiSegmentBuilder,
  } = useSegmentEditContext();

  const [fanFilterGroupId, setFanFilterGroupId] = useState(segment.fan_filter_group?.id || 0);
  const segmentPath = `/teams/${team.id}/segments/${segment.id}`;

  const done = () => {
    ensureConditionsComplete(team.id, fanFilterGroupId)
      .then((complete) => {
        if (complete) window.location.href = segmentPath;
      })
      .catch(() => toastError("Couldn't check the segment's conditions."));
  };

  return (
    <div style={pageStyle}>
      <PageHeader
        divider={false}
        title={segment.name}
        breadcrumbs={(
          <Breadcrumbs
            items={[
              { label: "Segments", href: listHref(`/teams/${team.id}/segments`) },
              { label: segment.name, href: segmentPath },
              { label: "Edit" },
            ]}
          />
        )}
        actions={(
          <Button variant="primary" onClick={done}>
            Done
          </Button>
        )}
      />
      {segment.type === "Segments::DataDriven" ? (
        <DataDrivenSegmentForm
          csrfToken={csrfToken}
          team={team}
          segment={segment}
          setSegment={setSegment}
          fanFilterGroupId={fanFilterGroupId}
          setFanFilterGroupId={setFanFilterGroupId}
          aiSegmentBuilder={aiSegmentBuilder}
          showAudienceEstimate
        />
      ) : null}
    </div>
  );
};

export default SegmentEdit;
